import { render, staticRenderFns } from "./component.vue?vue&type=template&id=1f97697c&lang=html&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f97697c')) {
      api.createRecord('1f97697c', component.options)
    } else {
      api.reload('1f97697c', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=1f97697c&lang=html&", function () {
      api.rerender('1f97697c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/directives/money/component.vue"
export default component.exports